import api from '../api/axios';

/** Appendix 1 參與者（儲存於 app1_content JSON 陣列中的每個元素） */
export interface Participant {
  org_name: string;
  country: number | null;   // system_codes.id (Article 6.4 Party)
  address: string | null;
  telephone: string | null;
  mobile: string | null;
  email: string | null;
  website: string | null;
  contact_person: string | null;
}

export interface AppendixDetail {
  id: number;
  organization_id: number;
  project_id: number;
  app1_content: string | null;   // JSON array of Participant
  app2_content: string | null;
  app3_content: string | null;
  app4_content: string | null;
  app5_content: string | null;
  app6_content: string | null;
  app6_file_id: number | null;
  app7_content: string | null;
  app7_file_id: number | null;
  app8_content: string | null;
  app8_file_id: number | null;
  section_app: number;
  edit_by: number | null;
  created_at: string | null;
  updated_at: string | null;
}

export type AppendixDetailUpdate = Partial<{
  app1_content: string | null;
  app2_content: string | null;
  app3_content: string | null;
  app4_content: string | null;
  app5_content: string | null;
  app6_content: string | null;
  app6_file_id: number | null;
  app7_content: string | null;
  app7_file_id: number | null;
  app8_content: string | null;
  app8_file_id: number | null;
}>;

const BASE = '/api/appendix';

const appendixService = {
  getDetailByProject: async (projectId: number): Promise<AppendixDetail | null> => {
    const res = await api.get<AppendixDetail | null>(`${BASE}/details/by-project/${projectId}`);
    return res.data;
  },

  saveDetail: async (projectId: number, data: AppendixDetailUpdate): Promise<AppendixDetail> => {
    const res = await api.put<AppendixDetail>(`${BASE}/details/${projectId}`, data);
    return res.data;
  },

  resetDetail: async (projectId: number): Promise<void> => {
    await api.post(`${BASE}/details/${projectId}/reset`);
  },
};

export default appendixService;
